const force_prod = true;
const enable_demo_mode = true; // Set to true to enable demo mode for the build, when the backend can't be reached and only the frontend is needed
const enable_caching = false; // set to true to enable 5-minute caching (reduces API calls)
const dev_show_all_listings = false; // when set to false, it defaults to showing only user's listings first.
const enable_console_logs = true; // set to false to silence console logs in production builds

// UPDATE THIS WHEN YOU DEPLOY
const last_updated = "April 28th, 2026";

function getApiBaseUrl() {
  const hostname = window.location.hostname;

  if (hostname.includes("localhost") && !force_prod) {
    return "http://localhost:8056";
  } else {
    return "https://api-punar.vrtta.green";
  }
}

export const apiUrl = getApiBaseUrl();
export const isDevelopment =
  window.location.hostname.includes("localhost") && !force_prod;
export const isDemoMode = enable_demo_mode; // Only shows when explicitly enabled
export const enableCaching = enable_caching; // Only caches when explicitly enabled
export const devShowAllListings = dev_show_all_listings; // Controls listing filter in dev mode
export const enableConsoleLogs = enable_console_logs; // Controls console log output
export const lastUpdated = last_updated; // Build deployment date

// protection settings to prevent rapid repeated API calls
export const protection = {
  cacheDuration: 5 * 60 * 1000, // 5 minutes (only applies when caching enabled)
  minRefreshInterval: 3000,
  minSaveInterval: 2000,
};

const config = {
  apiUrl,
  isDevelopment,
  isDemoMode,
  enableCaching,
  devShowAllListings,
  enableConsoleLogs,
  lastUpdated,
  protection,
};

export default config;
